import Vue from "vue";
import Vuex from "vuex";
import { TOURIST_LOGIN, USER_INFO } from '@/apis/user'
import { get, post } from '@/utils/http'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    safeArea: JSON.parse(localStorage.getItem("cdb_safe_area")) || {
      top: 0,
      bottom: 0
    },
    user: JSON.parse(localStorage.getItem("cdb_user")),
    userPwd: JSON.parse(localStorage.getItem("cdb_user_pwd")),
    token: localStorage.getItem("cdb_token"),
    loading: false,
    qrcode: sessionStorage.getItem("cdb_qrcode"),
    zhcode: sessionStorage.getItem("cdb_zhcode"),
    lang: localStorage.getItem("cdb_lang"),
    system: localStorage.getItem("cdb_system") || "",
    browser: localStorage.getItem("cdb_browser") || "",
    cabinet: JSON.parse(sessionStorage.getItem("cdb_cabinet")) || null,
    shopInfo: JSON.parse(sessionStorage.getItem("cdb_shop_info")) || {},
    localeArr: [
      // {
      //   key: 0,
      //   label: "简体中文",
      //   value: "zh-CN",
      //   currency: "元",
      //   money: "￥"
      // },
      {
        key: 1,
        label: "English",
        value: "en-US",
        currency: "dollar",
        money: "$"
      },
      {
        key: 2,
        label: "Français",
        value: "fr-FR",
        currency: "dollar",
        money: "$"
      }
      //   {
      //     key: 2,
      //     label: "Spanish",
      //     value: "es-ES",
      //     currency: "EUR",
      //     money: "€"
      //   }
    ],
    wallet: null,
    agentId: process.env.VUE_APP_PTID,
    appleIdToken: '',
    userType: JSON.parse(localStorage.getItem('cdb_user_type')) // 游客类型(tourist_login)
  },
  getters: {
    locale: state => {
      return state.localeArr.find(obj => obj.value === state.lang);
    }
  },
  mutations: {
    safeArea(state, payload) {
      localStorage.setItem("cdb_safe_area", JSON.stringify(payload));
      state.safeArea = payload;
    },
    user(state, payload) {
      localStorage.setItem("cdb_user", JSON.stringify(payload));
      state.user = payload;
    },
    userPwd(state, payload) {
      localStorage.setItem("cdb_user_pwd", JSON.stringify(payload));
      state.userPwd = payload;
    },
    token(state, payload) {
      localStorage.setItem("cdb_token", payload);
      state.token = payload;
    },
    loading(state, payload) {
      state.loading = payload;
    },
    qrcode(state, payload) {
      sessionStorage.setItem("cdb_qrcode", payload);
      state.qrcode = payload;
    },
    zhcode(state, payload) {
      sessionStorage.setItem("cdb_zhcode", payload);
      state.zhcode = payload;
    },
    lang(state, payload) {
      localStorage.setItem("cdb_lang", payload);
      state.lang = payload;
    },
    system(state, payload) {
      localStorage.setItem("cdb_system", payload);
      state.system = payload;
    },
    browser(state, payload) {
      localStorage.setItem("cdb_browser", payload);
      state.browser = payload;
    },
    cabinet(state, payload) {
      sessionStorage.setItem("cdb_cabinet", JSON.stringify(payload));
      state.cabinet = payload;
    },
    wallet(state, payload) {
      // sessionStorage.setItem('cdb_wallet', payload)
      state.wallet = payload;
    },
    shopInfo(state, payload) {
      sessionStorage.setItem("cdb_shop_info", JSON.stringify(payload));
      state.shopInfo = payload;
    },
    appleIdToken(state, payload) {
      state.appleIdToken = payload
    },
    userType (state, payload) {
      sessionStorage.setItem('cdb_user_type', JSON.stringify(payload))
      state.userType = payload
    }
  },
  actions: {
    loginTourist({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.token) {
          resolve(state.token)
          return
        }
        post(
          `${TOURIST_LOGIN}?code=${state.qrcode}`,
          {},
          resp => {
            if (resp.token) {
              commit('token', resp.token)
              commit('userType', 'tourist_login')
              resolve(resp.token)
            } else {
              reject(new Error('Visitor login is not supported'))
            }
          },
          error => {
            reject(error)
            console.log(error)
          }
        )
      })
    },
    loadUser({ commit }) {
      return new Promise((resolve, reject) => {
        get(
          USER_INFO,
          {},
          resp => {
            if (resp.user) {
              commit('user', resp.user)
              resolve(resp.user)
            } else {
              reject(new Error('Login Failed'))
            }
          },
          error => {
            reject(error)
          }
        )
      })
    }
  }
});
